/* eslint-disable */
import Vue from 'vue';
import vMessage from './index.vue';

// 创建Toast构造器
const vMessageConstrutor = Vue.extend(vMessage);
let instance;

const vMsg = function (options = {}) {
  // 设置默认参数为对象，如果参数为字符串，参数中message属性等于该参数
  // 创建实例
  instance = new vMessageConstrutor({
    data: options,
  });
  // 将实例挂载到body下
  document.body.appendChild(instance.$mount().$el);
};

export default vMsg;
